import { MIME_TYPES } from '@mantine/dropzone';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import ButtonLink from '../../elements/ButtonLink';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import RadioList from '../../elements/RadioList';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';
import LoadingBars from '../../elements/LoadingBars';

export default function Component({ handleSubmit, change, isLoading }) {
  const [ file, setFile] = useState(() => new FormData());
  const [error, setError] = useState('');
  const changeRef = useRef(change);
  const { values } = useSelector((state) => state.form.formUploadstockMerchant);
  const {
    isLoadingUploadStock, messageUploadStock
  } = useSelector((state) => state.updateStockMerchant);
  useEffect(() => {
    if(!isLoadingUploadStock && messageUploadStock){
      if(messageUploadStock.includes('required')) {
        setError('File harus diisi');
      }
    }
  },[isLoadingUploadStock, messageUploadStock]);

  const { type, propsfile } = fieldsProps;
  const items = [
    { label: 'Stok Penebusan', value: '1' },
    { label: 'Stok Akhir Bulan', value: '2' },
    { label: 'Stok Referensi', value: '3' }
  ];

  const onSelect = (files) => {
    const bodyFormData = new FormData();
    const selectedFile = files?.[0];

    if (selectedFile) {
      bodyFormData.set('file', selectedFile);
    }

    setFile(bodyFormData);
  };

  const hasFile = file instanceof FormData && file.has('file');
  const isSubmitDisabled = !values?.type || !hasFile || isLoading;

  changeRef.current = change;

  useEffect(() => {
    changeRef.current('file', hasFile ? file : '');
  }
  , [file, hasFile]);

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles['top-content-upload-reg-container']}>
        <div className={styles['left-content-upload-reg']}>
          Pilih file dengan format .csv
          untuk inject stok pangkalan LPG 3 kg dalam jumlah banyak
        </div>
        <div className={styles['right-content-upload-reg']}>
          <img className={styles['illustration-upload']} src="assets/illu-registrasi-pangkalan.svg"/>
        </div>
      </div>
      <Field
        component={RadioList}
        inputProps={type}
        items={items}
        name={type.name}
      />
      <ImagePicker
        accept={[MIME_TYPES.csv]}
        disabled={isLoading}
        {...propsfile}
        errorMessage={error}
        onSelect={onSelect}
        required
        setErrorMessage={setError}
      />
      <br/>
      <div className={styles['action-btn-container']}>
        <ButtonLink
          className={styles['action-btn-back']}
          disabled={isLoading}
          outlined={true}
          to={'/merchant/update-stock-merchant'}
        >
            Kembali
        </ButtonLink>
        <Button
          className={styles['action-btn-continue']}
          disabled={isSubmitDisabled} type="submit">
          {isLoading && <LoadingBars className={styles['loading-bars']} size={1}/> }
          {isLoading ? 'mengunggah...' : 'Unggah File Update Stok'}
        </Button>
      </div>
    </form>
  );
}

Component.defaultValue = {
  handleSubmit: () => {},
  change: () => { },
  isLoading: false,
};

Component.propTypes = {
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
